// extracted by mini-css-extract-plugin
export default {"cls1":"OU3mW3LO7x7_zgwFM7bB","cls2":"GhTol9uAIf0IoKLzfWNS OU3mW3LO7x7_zgwFM7bB"};